
export class LoginResult
{
    constructor(
        public Authorized: boolean,
        public Message: string = "")
    { }
}
